import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import { SelfServiceAPI } from 'types';

const hasExpiredCreditCardError = (errors: SelfServiceAPI.PlatformError[] | undefined) => {
  return !isEmpty(errors) && !!find(errors, { code: 'payment_failed_credit_card_expired' });
};

export default hasExpiredCreditCardError;
